
import AppViewEditor from "@/components/view-editor/ViewEditor.vue";
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { ViewService } from "@/services/view-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return{
			browse: null as Browse | null,
			view: null as View | null
		};
	},
	async created() {
		let browseID = parseInt(this.$route.params.id);
		let viewID = parseInt(this.$route.params.viewId);
		this.browse = (await BrowseService.getBrowse(browseID)).browse;
		let view = await ViewService.getView(viewID);
		view.BrowseID = browseID;
		view.Table = this.browse.Table;
		this.view = view;
	},
	components: {
		AppViewEditor
	}
});
